<template>
  <v-card elevation="0">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-row class="pa-0" v-if="currentResale && currentResale.id">
      <div>
        <v-icon class="d-flex-row justify-center" large color="normalred">
          mdi-cash-multiple
        </v-icon>

        <span class="text-span">Informações Bancarias</span>
      </div>

      <span class="pl-3 pb-2">
          Suas informações bancárias para receber seus pagamentos de comissões. Preencha
          todos os dados com atenção pois não será possível alterar depois, comprometendo
          seu pagamento.
      </span>
      <v-form
          class="form"
          :key="clear"
          ref="thirdForm"
          v-model="thirdValid"
          lazy-validation
      >
        <v-row class="pb-3 ma-0">
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                outlined
                hide-details
                maxlength="128"
                placeholder="Nome do recebedor"
                v-model="currentResale.nameReceiver"
                :label="'Nome do recebedor'"
                :rules="[rules.required]"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                outlined
                hide-details
                placeholder="E-mail do recebedor"
                v-model="currentResale.eMailReceiver"
                :label="'E-mail'"
                :rules="[rules.required, rules.emailRules]"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                outlined
                hide-details
                maxlength="256"
                placeholder="Descrição do recebedor"
                v-model="currentResale.description"
                :label="'Descrição do recebedor'"
                :rules="[rules.required]"
                required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="pb-3 ma-0">
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                outlined
                placeholder="Titular da Conta"
                v-model="currentResale.holderName"
                :label="'Titular da Conta'"
                :rules="[rules.required, (v) => v.length <= 30 || 'O nome do titular deve possuir 30 caracteres no máximo']"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                outlined
                maxlength="3"
                v-mask="'###'"
                hint="Ex: 099"
                persistent-hint
                placeholder="Código do Banco"
                v-model="currentResale.bank"
                :label="'Código do Banco'"
                :rules="[rules.required, (v) => v.length >= 3 || 'O Código do Banco deve possuir no minimo 3 caracteres']"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                clearable
                outlined
                placeholder="Número da agência"
                hide-details
                maxlength="4"
                v-mask="'####'"
                v-model="currentResale.branchMumber"
                :rules="[rules.required]"
                :label="'Número da agência'"
                rounded
                required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="pb-3 ma-0">
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                outlined
                hide-details
                maxlength="1"
                v-mask="'#'"
                placeholder="Digito da agência"
                v-model="currentResale.branchCheckDigit"
                :label="'Digito da agência'"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                outlined
                hide-details
                maxlength="13"
                v-mask="'#############'"
                placeholder="Número da conta"
                v-model="currentResale.accountNumberReceiver"
                :label="'Número da conta'"
                :rules="[rules.required]"
                required
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                clearable
                outlined
                placeholder="Digito da conta"
                hide-details
                maxlength="2"
                v-mask="'##'"
                v-model="currentResale.accountCheckDigit"
                :rules="[rules.required]"
                :label="'Digitos da conta'"
                rounded
                required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="pb-3 ma-0">
          <v-col cols="12" sm="12" md="4" lg="4">
            <v-text-field
                clearable
                outlined
                placeholder="CNPJ/CPF do titular da conta"
                v-model="currentResale.document"
                :rules="[rules.required, rules.validateCPF, rules.validateCNPJ]"
                v-mask="this.isEditing  ? null  : currentResale.document.length <= 14  ? '###.###.###-##' : '##.###.###/####-##'"
                :label="'CNPJ/CPF do titular da conta'"
                rounded
                required
            ></v-text-field>
          </v-col>



          <v-col cols="12" sm="12" md="4" lg="4">
            <v-select
                outlined
                hide-details
                placeholder="Tipo de conta"
                v-model="currentResale.accountTypeReceiver"
                :items="tipoConta"
                item-text="descrption"
                item-value="value"
                :label="'Tipo de conta'"
                :rules="[rules.required]"
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-row>

    <v-row class="pb-3" justify="center">
      <v-col cols="12" md="6">
        <v-btn
            class="primary-button"
            color="normalred"
            elevation="0"
            @click="validate()"
            block
        >
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";
import Utils from "../../../../Utils/ValidateCPFCNPJ";

export default {
  name: "BankInformation",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    typeManually: false,
    thirdValid: true,
    clear: false,
    naoLocalizado: false,
    hasAddressNumber: true,
    loading: true,
    currentResale: {
      image: "",
      Name: "",
      defaultFrete: "",
      agreement: false,
      cnpj: "",
      inscrEstadual: "",
      phoneNumber: "",
      phoneNumber2: "",
      birthDate: "",
      postalCode: "",
      state: "",
      city: "",
      neighborhood: "",
      addressName: "",
      addressNumber: "",
      country: "",
      addressComplement: "",
      resaleRegion: "",
      category: "",
      region: "",
      password: "",
      password2: "",
      email: "",
      email2: "",
      resaleWebSite: "",
      receiveEmail: "",
      receiveSms: "",
      textObservation: "",
      tokenMelhorEnvio: "",
      latitude: null,
      longitude: null,
      document: "",
      bank: "",
      holderName: "",
      transferEnabled: "",
      transferInterval: "",
    },
    apiService: new ApiService(),
    daysOfTheMonth: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
    daysOfTheWeek: [
      {
        day: '1',
        descrption: 'Segunda-feira'
      },
      {
        day: '2',
        descrption: 'Terça-feira'
      },
      {
        day: '3',
        descrption: 'Quarta-feira'
      },
      {
        day: '4',
        descrption: 'Quinta-feira'
      },
      {
        day: '5',
        descrption: 'Sexta-feira'
      }
    ],
    frequenciaTransferencia: [
      {
        value: 'daily',
        descrption: 'Diária'
      },
      {
        value: 'weekly',
        descrption: 'Semanal'
      },
      {
        value: 'monthly',
        descrption: 'Mensal'
      }
    ],
    tipoConta: [
      {
        value: 'checking',
        descrption: 'Conta Corrente'
      },
      {
        value: 'savings',
        descrption: 'Poupança'
      },
    ],
    tipoDocumento: [
      {
        value: 'individual',
        descrption: 'CPF'
      },
      {
        value: 'company',
        descrption: 'CNPJ'
      },
    ],
    user: {},
    dialog: false,
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    specialties: [],
    isEditing: false,
    rules: {
      nameRules: (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
      required: (value) => !!value || "Campo requerido.",
      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
      postalCodeRules: (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
      validateCPF: (value) => (Utils.CPF(value) || value.toString().replace(/\D/g, "").length > 11) || 'Cpf Inválido',
      validateCNPJ: (value) => (Utils.CNPJ(value) || value.toString().replace(/\D/g, "").length <= 11) || 'Cnpf Inválido'
    },
  }),
  async created() {
    await this.updateUser();
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    updateTransferDay() {
      this.currentResale.transferDay = null
    },
    async updateUser() {
      try {
        this.loading = true;
        let user = JSON.parse(localStorage.getItem("user"));

        this.Id = user.id;
        await this.apiService.get(`resale/get-one?id=${this.Id}`).then((response) => {
          this.currentResale = response;
          this.currentResale.transferEnabled = "Não"
          this.currentResale.transferInterval = this.currentResale.transferInterval.toLocaleLowerCase()
          setTimeout(() =>{
            this.currentResale.transferDay =  this.currentResale.transferDay ? this.currentResale.transferDay.toString() : 0
          }, 100)
          console.log('this.currentResale')
          console.log(this.currentResale)
          console.log('this.currentResale')
          this.loading = false;
        });
      } catch (e) {

      }
    },
    validate() {
      if (this.$refs.thirdForm.validate()) {
        this.dialog = true;
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });
      }
    },

    async submit() {
      try {
        const resaleModified = {
          Id: this.currentResale.id,
          Name: this.currentResale.name,
          Password: this.currentResale.password,
          Cnpj: this.currentResale.cnpj,
          InscrEstadual: this.currentResale.inscrEstadual,
          NameFantasy: this.currentResale.nameFantasy,
          PhoneNumber: this.currentResale.phoneNumber,
          PhoneNumber2: this.currentResale.phoneNumber2,
          Email: this.currentResale.email,
          Country: this.currentResale.country,
          BirthDate: this.currentResale.birthDate,
          AddressNumber: this.currentResale.addressNumber,
          PostalCode: this.currentResale.postalCode,
          Neighborhood: this.currentResale.neighborhood,
          AddressName: this.currentResale.addressName,
          State: this.currentResale.state,
          AddressComplement: this.currentResale.addressComplement,
          City: this.currentResale.city,
          ReceiveSms: this.currentResale.receiveSms,
          Region: this.currentResale.region,
          Category: this.currentResale.category,
          Observations: this.currentResale.textObservation,
          ReceiveEmail: this.currentResale.receiveEmail,
          AccountNumber: this.currentResale.accountNumber,
          AgencyNumber: this.currentResale.agencyNumber,
          AccountBank: this.currentResale.accountBank,
          AccountType: this.currentResale.accountType,
          Status: this.currentResale.status,
          Latitude: this.currentResale.latitude,
          Longitude: this.currentResale.longitude,

          NameReceiver: this.currentResale.nameReceiver,
          EMailReceiver: this.currentResale.eMailReceiver,
          Description: this.currentResale.description,
          Document: this.currentResale.document,
          TypeReceiver: this.currentResale.typeReceiver,
          CodeReceiver: this.currentResale.codeReceiver,
          HolderName: this.currentResale.holderName,
          Bank: this.currentResale.bank,
          BranchMumber: this.currentResale.branchMumber,
          BranchCheckDigit: this.currentResale.branchCheckDigit,
          AccountNumberReceiver: this.currentResale.accountNumberReceiver,
          AccountCheckDigit: this.currentResale.accountCheckDigit,
          HolderYype: this.currentResale.length === 11 ? 'individual' : 'company',
          HolderDocument: this.currentResale.document,
          TransferEnabled: false,
          TransferInterval: this.currentResale.transferInterval,
          TransferDay: this.currentResale.transferInterval === 'daily' ? 0 : this.currentResale.transferDay,
          GatewayRecipientsStatus: this.currentResale.gatewayRecipientsStatus,
          AccountTypeReceiver: this.currentResale.accountTypeReceiver,
        };
        this.dialog = false;
        this.loading = false;
        await this.apiService.put(`resale/edit/account/${this.currentResale.id}`, resaleModified)
            .then((resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: resp.message,
                message: resp.message,
                trace: null,
              });
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro ao cadastrar produto",
                message: err.body.message,
                trace: null,
              });
            });
        await this.updateUser();
      } catch (e) {
        console.log(e)
      }
    },
  },
  watch: {

  }
};
</script>
<style scoped>
</style>
